import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Document } from '../document';
import { DocumentsService } from '../documents.service';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css'],
  providers: [ DocumentsService ]
})


export class DocumentComponent implements OnInit {
	// document: {};
	document: Document;
	constructor(
		private activatedRoute: ActivatedRoute,
		private documentsService: DocumentsService) {
	}
	getDoc (id: number) {
		this.documentsService
			.getDoc(id)
			.subscribe( (doc: Document) => this.document = doc );
	}
	ngOnInit() {
		this.activatedRoute
			.params
			.subscribe(
				params => {
					//console.log(params);
					this.getDoc( params['id'] );
				}
			);

	}
}


// WEBPACK FOOTER //
// ./src/app/document/document.component.ts